import { render, staticRenderFns } from "./TargetedPopulation.vue?vue&type=template&id=ce32038a&scoped=true"
import script from "./TargetedPopulation.vue?vue&type=script&lang=js"
export * from "./TargetedPopulation.vue?vue&type=script&lang=js"
import style0 from "./TargetedPopulation.vue?vue&type=style&index=0&id=ce32038a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce32038a",
  null
  
)

export default component.exports